import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "layoutwindow"
    }}>{`LayoutWindow`}</h1>
    <p>{`A layout window.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`AFTER_SELECTION_CHANGED`}</strong>{` = afterSelectionChanged`}</p>
      <p parentName="blockquote">{`Dispatched after the active selection changes. This event bubbles. This event is not cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`AFTER_SELECTION_ATTRIBUTE_CHANGED`}</strong>{` = afterSelectionAttributeChanged`}</p>
      <p parentName="blockquote">{`Dispatched after an attribute on the active selection changes. This event bubbles. This event is not cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`BEFORE_DEACTIVATE`}</strong>{` = beforeDeactivate`}</p>
      <p parentName="blockquote">{`Dispatched before the LayoutWindow becomes inactive. This event bubbles. This event is not cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`AFTER_ACTIVATE`}</strong>{` = afterActivate`}</p>
      <p parentName="blockquote">{`Dispatched after the LayoutWindow becomes active. This event bubbles. This event is not cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`AFTER_ATTRIBUTE_CHANGED`}</strong>{` = afterAttributeChanged`}</p>
      <p parentName="blockquote">{`Dispatched when the value of a property changes on this LayoutWindow. This event bubbles. This event is not cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`AFTER_OPEN`}</strong>{` = afterOpen`}</p>
      <p parentName="blockquote">{`Dispatched after a LayoutWindow is opened. This event bubbles. This event is not cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`BEFORE_CLOSE`}</strong>{` = beforeClose`}</p>
      <p parentName="blockquote">{`Dispatched before a LayoutWindow is closed. This event bubbles. This event is cancelable.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`AFTER_CLOSE`}</strong>{` = afterClose`}</p>
      <p parentName="blockquote">{`Dispatched when a LayoutWindow is closing. Since the close has been committed, it can no longer be canceled. This event bubbles. This event is not cancelable.`}</p>
    </blockquote>
    <h2 {...{
      "id": "instance"
    }}>{`Instance`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`name`}</strong>{` `}</p>
      <p parentName="blockquote">{`The name of the LayoutWindow.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`isValid`}</strong>{` `}</p>
      <p parentName="blockquote">{`Returns true if the object specifier resolves to valid objects.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Document `}<strong parentName="p">{`parent`}</strong>{` `}</p>
      <p parentName="blockquote">{`The parent of the LayoutWindow (a Document).`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`index`}</strong>{` `}</p>
      <p parentName="blockquote">{`The index of the LayoutWindow within its containing object.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Events `}<strong parentName="p">{`events`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of events.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`EventListeners `}<strong parentName="p">{`eventListeners`}</strong>{` `}</p>
      <p parentName="blockquote">{`A collection of event listeners.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`overprintPreview`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, display a simulation of overprinting.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`proofingProfile`}</strong>{` `}</p>
      <p parentName="blockquote">{`The profile used for proofing colors.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`ProofingType `}<strong parentName="p">{`proofingType`}</strong>{` `}</p>
      <p parentName="blockquote">{`The method of proofing colors.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`simulateInkBlack`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, simulates the dark gray produced by many printers in place of solid black, according to the proofing profile. Note: Valid only when proofing type is custom.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`simulatePaperWhite`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, simulates the dingy white of real paper, according to the proofing profile. Note: Valid only when proofing type is custom.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`preserveColorNumbers`}</strong>{` `}</p>
      <p parentName="blockquote">{`If true, leaves color values unchanged for CMYK objects without embedded profiles and native objects such as line art or type. Note: Converts images whose profiles differ from the profile of the simulated device. Valid only when proofing type is custom.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`ViewDisplaySettings `}<strong parentName="p">{`viewDisplaySetting`}</strong>{` `}</p>
      <p parentName="blockquote">{`The display performance preferences override for the view.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`transformReferencePoint`}</strong>{` `}</p>
      <p parentName="blockquote">{`The default anchor point around which to transform objects. Can return: AnchorPoint enumerator or Array of 2 Units.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Layer `}<strong parentName="p">{`activeLayer`}</strong>{` `}</p>
      <p parentName="blockquote">{`The active layer. Can also accept: String.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`zoomPercentage`}</strong>{` `}</p>
      <p parentName="blockquote">{`The size (as a percentage) to which to enlarge or reduce the view of the document. (Range: 5 to 4000)`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Mixed `}<strong parentName="p">{`activeSpread`}</strong>{` `}</p>
      <p parentName="blockquote">{`The front-most spread. Can return: Spread or MasterSpread.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Page `}<strong parentName="p">{`activePage`}</strong>{` `}</p>
      <p parentName="blockquote">{`The front-most page.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`ScreenModeOptions `}<strong parentName="p">{`screenMode`}</strong>{` `}</p>
      <p parentName="blockquote">{`The screen mode for layout view.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Object `}<strong parentName="p">{`selection`}</strong>{` `}</p>
      <p parentName="blockquote">{`The selected object(s). Can also accept: Object or NothingEnum enumerator.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`bounds`}</strong>{` `}</p>
      <p parentName="blockquote">{`The bounds of the window (specified in pixels) in the form `}{`[top, left, bottom, right]`}{`.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`PageItem `}<strong parentName="p">{`selectionKeyObject`}</strong>{` `}</p>
      <p parentName="blockquote">{`The key object of the selection. Can also accept: NothingEnum enumerator.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`Object `}<strong parentName="p">{`properties`}</strong>{` `}</p>
      <p parentName="blockquote">{`A property that allows setting of several properties at the same time.`}</p>
    </blockquote>
    <h3 {...{
      "id": "methods"
    }}>{`Methods`}</h3>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`zoom`}</strong>{`( ZoomOptions `}<strong parentName="p">{`given`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Magnifies or reduces the window to the specified display size.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`ZoomOptions`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`given`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The display size.`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`select`}</strong>{`( Mixed `}<strong parentName="p">{`selectableItems`}</strong>{`, SelectionOptions `}<strong parentName="p">{`existingSelection`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Selects the specified object(s).`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-1"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`selectableItems`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The objects to select. Can accept: Object, Array of Objects, NothingEnum enumerator or SelectAll enumerator.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`SelectionOptions`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`existingSelection`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The selection status of the LayoutWindow in relation to previously selected objects. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`close`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Closes the LayoutWindow.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><strong parentName="p">{`maximize`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Maximizes the window.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><strong parentName="p">{`minimize`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Minimizes the window.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><strong parentName="p">{`restore`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Restores the window.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><strong parentName="p">{`bringToFront`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Brings the object to the front.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSource`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Generates a string which, if executed, will return the LayoutWindow.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`LayoutWindow `}<strong parentName="p">{`getElements`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Resolves the object specifier, creating an array of object references.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`String `}<strong parentName="p">{`toSpecifier`}</strong>{`()`}</p>
      <p parentName="blockquote">{`Retrieves the object specifier.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote">{`EventListener `}<strong parentName="p">{`addEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Adds an event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-2"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>
    <hr></hr>
    <blockquote>
      <p parentName="blockquote">{`Boolean `}<strong parentName="p">{`removeEventListener`}</strong>{`( String `}<strong parentName="p">{`eventType`}</strong>{`, Mixed `}<strong parentName="p">{`handler`}</strong>{`, Boolean `}<strong parentName="p">{`captures`}</strong>{` )`}</p>
      <p parentName="blockquote">{`Removes the event listener.`}</p>
      <h4 parentName="blockquote" {...{
        "id": "parameters-3"
      }}>{`Parameters`}</h4>
      <table parentName="blockquote">
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Type`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`Description`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`String`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`eventType`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event type.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Mixed`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`handler`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`The registered event handler. Can accept: File or JavaScript Function.`}</td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Boolean`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`captures`}</td>
            <td parentName="tr" {...{
              "align": null
            }}>{`This parameter is obsolete. (Optional)`}</td>
          </tr>
        </tbody>
      </table>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      